import React from "react";
import CommonBanner from "../component/Common/CommonBanner";
import FlightPaymentArea from "component/FlightPayment";
import { useTranslation } from "react-i18next";
const FlightPayment = () => {
    const { t } = useTranslation();
    return (
        <>
            <CommonBanner
                heading={t("paymentSubmission")}
                pagination="Booking submission"
            />
            <FlightPaymentArea />
        </>
    );
};

export default FlightPayment;
